import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewEncapsulation } from '@angular/core';
import { Spettacolo } from '../../shared/interface';
import { ApiService } from '../../services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Dialog, DialogRef } from '@angular/cdk/dialog';

@Component({
  selector: 'app-spettacolo',
  templateUrl: './spettacolo.component.html',
  styleUrl: './spettacolo.component.css',
  encapsulation: ViewEncapsulation.None,
  animations: []
})
export class SpettacoloComponent implements OnInit {

  constructor(private apiService: ApiService, private route: ActivatedRoute, private router: Router, private cdr: ChangeDetectorRef, private dialog: Dialog) { }

  carica: boolean = true;

  spettacolo?: Spettacolo;
  spettacoli: Spettacolo[] = [];

  casts: string[] = [];

  pdf_timeline: string = '';
  image_pdf_timeline: string = '';
  show_pdf_timeline: boolean = false;

  popupImage: DialogRef<any, unknown> | undefined;

  ngOnInit(): void {

    // Recupero i parametri passati nell'url
    this.route.params.subscribe(params => {

      // Recupero l'url della news
      const spettacolo: string = params['titolo'].replace(/\-/gi, "%").replace(/\ /gi, "%");
      const dal = params['dal'];
      const al = params['al'];

      //Recupero i dati dello spettacolo
      this.apiService.getSpettacoloByName(spettacolo, dal, al).subscribe({
        next: (data) => this.spettacolo = data,
        error: (err) => this.router.navigate(['/']),
        complete: () => {

          this.spettacolo?.timeline!.filter(timeline => timeline.pdf).map(timeline => {
            this.pdf_timeline = timeline.pdf;
            this.image_pdf_timeline = timeline.pdf_image || ''
            this.show_pdf_timeline = true
          })

          //Spettacoli consigliati
          this.apiService.getSpettacoli().subscribe({
            next: (data) => this.spettacoli = [...data],
            error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
            complete: () => {

              // Recupero gli spettacoli in base alle suggestioni
              this.spettacoli = this.spettacolo?.suggestioni!.map(suggerito => {
                return this.spettacoli.filter(spettacolo => spettacolo.id == suggerito.id_suggestione)[0]
              }) || [];

              this.casts = this.spettacolo?.cast!.map((cast: any) => cast.ruolo).filter((value: any, index: any, self: any) => self.indexOf(value) === index) || []

              this.carica = false;
              this.cdr.detectChanges();

            }
          })
        },
      });
    })
  }

  openImg(template: TemplateRef<unknown>) {
    this.popupImage = this.dialog.open(template);
  }

  prezziLength(col: string) {    
    return this.spettacolo?.prezzi.filter((prezzo: any) => prezzo[col] != 0 ).length;
  }

}
